/* eslint-disable import/no-unresolved */
import { Box, LinkBox, LinkOverlay } from "@chakra-ui/react";
import { GiAmpleDress } from "react-icons/gi";
import { LuLeafyGreen } from "react-icons/lu";
import { MdOutlineContactSupport } from "react-icons/md";
import { PiHandCoins } from "react-icons/pi";

import { channelSlug } from "@app/constants";

import * as S from "./styles";

const supportHref =
  channelSlug === "volte-uk"
    ? "https://thevolteuk.zendesk.com/hc/en-us"
    : "https://thevolte.zendesk.com/hc/en-au";

const items = [
  {
    href: "/dresses",
    icon: <GiAmpleDress size={32} />,
    title: "ENDLESS DRESS HIRE OPTIONS",
    description:
      "Explore a vast collection of designer dress rentals from renowned Australian and international designers.",
  },
  {
    href: "/dashboard",
    icon: <PiHandCoins size={32} />,
    title: "SHARE AND EARN",
    description:
      "Earn by sharing and renting your wardrobe, with opt-in insurance keeping you protected.",
  },
  {
    href: "/wear-the-dress-share-the-dress",
    icon: <LuLeafyGreen size={32} />,
    title: "CIRCULAR FASHION",
    description:
      "Dress hire on the Volte champions sustainability and circular fashion.",
  },
  {
    href: supportHref,
    icon: <MdOutlineContactSupport size={32} />,
    title: "24/7 SUPPORT",
    description:
      "Around-the-Clock support for your dress rental enquiries. Click Live Chat or contact us via phone or email.",
  },
];

export const ContactDetails = () => (
  <S.ScrollableContainer>
    <S.StyledUSP>
      {items?.map((item, index) => (
        <S.StyledBoxContainer key={index}>
          <LinkBox display="flex" h="100%">
            <S.StyledBox>
              {item.icon}
              <Box as="h3" fontWeight={600} fontSize={16} lineHeight="normal">
                <LinkOverlay fontWeight="bold" href={item.href}>
                  {item.title}
                </LinkOverlay>
              </Box>
              <Box as="p">{item.description}</Box>
            </S.StyledBox>
          </LinkBox>
        </S.StyledBoxContainer>
      ))}
    </S.StyledUSP>
  </S.ScrollableContainer>
);
